<template>
	<div
		ref="modalBookmarks"
		class="cm-modal modal fade modal-bookmarks"
		id="modalBookmarks"
		tabindex="-1"
		aria-labelledby="modalBookmarks"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<p class="lead modal-title" id="modalBookmarksLabel">
						Mein Merkzettel ({{ totalCarBookmarks }})
					</p>
					<button
						type="button"
						class="btn-close"
						data-bs-dismiss="modal"
						aria-label="Close"
					></button>
				</div>
				<div class="modal-body">
					<div class="bookmark-items">
						<transition-group name="cm-shrink-y" mode="in-out">
							<div
								v-if="totalCarBookmarks === 0"
								class="text-center border-bottom py-3"
							>
								<i class="mdi mdi-star-off mdi-48px text-muted"></i>
								<p class="lead text-center text-muted mb-4">
									Keine Fahrzeuge vorhanden
								</p>
								<button
									type="button"
									class="btn btn-outline-light btn-pill"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<i class="mdi mdi-close-thick"></i> Schließen
								</button>
							</div>
							<template v-else v-for="item in bookmarkedCars" :key="item.id">
								<div class="bookmark-item row g-0 align-items-center">
									<div class="bookmark-start col-auto">
										<button
											type="button"
											class="btn px-3 btn-white text-danger"
											@click="removeCarFromBookmarks(item.id)"
											title="Zeige Fahrzeugdetails"
										>
											<i class="mdi mdi-delete"></i>
										</button>
									</div>
									<div class="col bookmark-content">
										<h5>{{ item.title }}</h5>
										<div
											class="bookmark-subtext text-truncate text-nowrap w-100"
										>
											<span class="text-success font-600"
												>{{ getPrice(item.price) }} €</span
											>
											<span
												v-if="item.useageType !== undefined"
												class="d-none d-md-inline-block"
												>{{ item.useageType }}</span
											>
											<span v-else class="d-none d-md-inline-block">{{
												item.condition
											}}</span>
											<span class=""
												>Angebots-Nr. {{ item.internalNumber }}</span
											><span class="border-end-0 d-none d-md-inline-block"
												>Gemerkt am
												{{ formatDate(item.creationDate) }}
											</span>
										</div>
									</div>
									<div class="bookmark-end col-auto">
										<div class="btn-group">
											<a
												class="btn btn-white d-none"
												title="PDF herunterladen"
												target="_blank"
												:href="
													'https://mobile.dispo24.de:8031/v1/mobile-de/create/darmasad/pdf/internalNumber/' +
													item.internalNumber
												"
											>
												<i class="mdi mdi-download"></i> PDF
											</a>
											<button
												type="button"
												class="btn btn-dark"
												data-bs-dismiss="modal"
												@click="goToCarDetails(item.id)"
												title="Zeige Fahrzeugdetails"
											>
												<i class="mdi mdi-magnify"></i>
											</button>
										</div>
									</div>
									<div class="bookmark-bottom">
										<div class="row g-0">
											<div class="col-auto me-auto">
												<button
													type="button"
													class="btn btn-white text-danger"
													@click="this.removeCarFromBookmarks(item.id)"
													title="Zeige Fahrzeugdetails"
												>
													<i class="mdi mdi-delete"></i>
												</button>
											</div>
											<div class="col-auto">
												<button
													type="button"
													class="ms-3 btn btn-dark"
													data-bs-dismiss="modal"
													@click="goToCarDetails(item.id)"
													title="Zeige Fahrzeugdetails"
												>
													Details <i class="mdi mdi-chevron-right"></i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</template>
						</transition-group>
					</div>
					<div class="modal-text bg-lighter p-3 p-lg-4 d-flex w-100">
						<i class="bi bi-info-circle font-gray-600 font-32 mt-2 me-3"></i>
						<p class="font-14 font-gray-600 lh-base">
							Bitte beachten Sie das gespeicherte Fahrzeuge nur auf dem gerade
							verwendetem Browser/Gerät gespeichert werden. Diese werden für
							unbegrenzte Zeit auf Ihrem Gerät gespeichert und können in der
							Zwischenzeit verkauft werden.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
	name: 'ListModalBookmarks',
	computed: {
		totalCarBookmarks() {
			return Object.keys(store.state.user.bookmarks.cars).length
		},
		totalSearchBookmarks() {
			return store.state.user.bookmarks.search ? 1 : 0
		},
		bookmarkedCars() {
			return store.state.user.bookmarks.cars
		},
	},
	methods: {
		goToCarDetails(carId) {
			router.push({ name: 'Details', params: { id: carId } })
		},
	},
}
</script>

<style scoped></style>
